<template>
  <div class="pc-header">
    <div
      class="page-logo"
      style="position:relative"
    >
      <a
        class="logo"
        href="/"
      ></a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Header",
  props: {},
  data() {
    return {};
  },
  computed: mapState({}),
  methods: {
    ...mapActions([])
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
.pc-header {
    position: relative;
    padding: 30px 50px;
    a.logo {
        display: inline-block;
        width: 180px;
        height: 30px;
        background: url('../../assets/common/logo.png') no-repeat;
        background-size: contain;
    }
    a.login {
        position: absolute;
        right: 70px;
        color: #fff;
        line-height: 35px;
        display: inline-block;
        width: 60px;
        letter-spacing: 1px;
    }
    a.signup{
        position: absolute;
        right: 0;
        color: #fff;
        line-height: 35px;
        letter-spacing: 1px;
    }
    a:hover{
        color: #11B8BB;
        transition: color 0.4s ease 0s;
    }
}


@media (max-width: 640px) {
    .pc-header {
        display: none;
    }
}

</style>
